import { useEffect, useState } from 'react'

interface UseDebouncedValueResult<T> {
	debouncedValue: T
	isPending: boolean
}

export const useDebouncedValue = <T>(
	value: T,
	delay = 600,
): UseDebouncedValueResult<T> => {
	const [debouncedValue, setDebouncedValue] = useState(value)

	useEffect(() => {
		const timeout = window.setTimeout(() => {
			setDebouncedValue(value)
		}, delay)

		return () => window.clearTimeout(timeout)
	}, [value, delay])

	return {
		debouncedValue,
		isPending: value !== debouncedValue,
	}
}
